import useUsers from '@hooks/api/queries/users/useUsers';
import { Box } from '@mui/material';
import { DataGridPro, GridColDef } from '@mui/x-data-grid-pro';
import useAlias from '@src/hooks/useAlias';
import { User } from '@src/types/User';
import DeleteUserButton from './DeleteUserButton';
import EditUserButton from './EditUserButton';
import UsersListGridToolbar from './UsersListGridToolbar';

function UsersList() {
  const { data: users, isLoading, isFetching } = useUsers();
  const alias = useAlias();

  const columns: GridColDef<User>[] = [
    {
      headerName: alias('Username'),
      field: 'username',
      sortable: true,
      flex: 1,
    },
    {
      headerName: alias('Name'),
      field: 'name',
      sortable: true,
      valueGetter: (_value, row: User) =>
        `${row.firstName ?? ''} ${row.lastName ?? ''}`,
      flex: 1,
    },
    {
      headerName: alias('Email'),
      field: 'email',
      sortable: true,
      flex: 1,
    },
    {
      headerName: alias('Groups'),
      field: 'groups',
      sortable: true,
      flex: 1,
    },
    {
      headerName: alias('MFA Enabled'),
      field: 'totp',
      sortable: true,
      flex: 1,
      hideable: true,
    },
    {
      headerName: '',
      field: 'actions',
      width: 100,
      sortable: false,
      filterable: false,
      renderCell: ({ row }: { row: User }) => (
        <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
          <EditUserButton userId={row.id} />
          <DeleteUserButton user={row} />
        </Box>
      ),
    },
  ];

  return (
    <DataGridPro
      loading={isLoading || isFetching}
      rows={users ?? []}
      columns={columns}
      slots={{ toolbar: UsersListGridToolbar }}
      slotProps={{
        toolbar: {
          showQuickFilter: true,
          printOptions: { disableToolbarButton: true },
        },
      }}
      density='comfortable'
      checkboxSelection
      disableRowSelectionOnClick
      localeText={{
        toolbarColumns: alias('Columns'),
        toolbarFilters: alias('Filters'),
        toolbarExport: alias('Export'),
        toolbarQuickFilterPlaceholder: alias('Search...'),
      }}
    />
  );
}

export default UsersList;
